import { useAppState } from "src/state";

import { TalentAdminBookingViewSchema } from "src/components/talent/bookings/TalentAdminBookingViewSchema";
import { Icons } from "src/components/ui/Icons";
import { ViewSchemaRenderer } from "src/components/ui/ViewSchemaRenderer";

export function TalentAdminBookingView() {

    const { currentItem } = useAppState().bookings;

    if (!currentItem) return null;

    return (
        <ViewSchemaRenderer
            schema={TalentAdminBookingViewSchema}
            data={currentItem}
            title="Booking Overview"
            icon={Icons.booking}
        />
    );
}